import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export const useRecaptcha = () => {
  const siteKey = import.meta.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const recaptchaHook = useGoogleReCaptcha();

  if (!siteKey) {
    return { executeRecaptcha: null };
  }

  if (!recaptchaHook || !recaptchaHook.executeRecaptcha) {
    return { executeRecaptcha: null };
  }

  return { executeRecaptcha: recaptchaHook.executeRecaptcha };
};
